import type { LocalDate } from "@js-joda/core";
import type {
  StaffProfileData,
  StaffProfileResponseV3,
} from "services/api/company/staff.service";
import { getStockholmLocalDateNow } from "web-apps/company/utils/timeAndDate";
import { toLocalDateOrNull } from "../domains/employment/profilePanel.payload.logic";
import { performSaveEmployment as runPerformSaveEmployment } from "./profilePanel.state.employment.logic";
import { toEmploymentDetailsForm } from "./profilePanel.state.formMappers.logic";
import { EmploymentUiRules } from "../../shared/staffEmploymentRules.logic";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

interface ConfirmEndEmploymentUpdateParams {
  companyId: number | null;
  employmentRules: EmploymentUiRules;
  endEmploymentDate: LocalDate | null;
  isSaving: boolean;
  onSuccess: () => void;
  onWorkerUpdated?: () => void;
  profile: StaffProfileData | null;
  applySavedProfile: (savedProfile: StaffProfileResponseV3) => void;
  setIsSaving: (value: boolean) => void;
  setSaveError: (value: string) => void;
  translate: TranslateFn;
  workerId: number | null;
}

/**
 * Today, unless the employment has not started yet or starts today: then the day after its startdate.
 */
export const toSuggestedEndEmploymentDate = (
  selectedEmploymentStartDate: LocalDate | null,
): LocalDate => {
  const today = getStockholmLocalDateNow();

  return selectedEmploymentStartDate != null &&
    !today.isAfter(selectedEmploymentStartDate)
    ? selectedEmploymentStartDate.plusDays(1)
    : today;
};

export const confirmEndEmploymentUpdate = (
  params: ConfirmEndEmploymentUpdateParams,
): void => {
  if (params.isSaving) return;
  if (params.endEmploymentDate == null) {
    params.setSaveError(params.translate("Alerts.SomethingWentWrong"));
    return;
  }

  const selectedEmployment = params.profile?.employmentInfo?.selected;
  const startDate = toLocalDateOrNull(selectedEmployment?.startDate);

  runPerformSaveEmployment({
    companyId: params.companyId,
    workerId: params.workerId,
    profile: params.profile,
    editedEmploymentDetails: toEmploymentDetailsForm(params.profile),
    editingTab: "employmentSalary",
    employmentRules: params.employmentRules,
    startDate,
    endDate: params.endEmploymentDate,
    translate: params.translate,
    setIsSaving: params.setIsSaving,
    setSaveError: params.setSaveError,
    setEditingTab: (): void => undefined,
    setModalState: (): void => params.onSuccess(),
    applySavedProfile: params.applySavedProfile,
    onWorkerUpdated: params.onWorkerUpdated,
  });
};
